import React from 'react';
import { connect } from 'react-redux';
import AdvertModal from 'src/modules/shared/modal/components/advertModal';
import { setupGPT } from 'src/utils/adverts';
import { isUserBot } from 'src/utils/seo';
import Router from 'next/router';

const handleRouteChange = () => {
  googletag.cmd.push(() => googletag.destroySlots());
};

// Do not change to a functional component, it needs to be called before
// the AdvertModal components. As a class, it's called before them.
class AdvertModalContainer extends React.Component {
  componentDidMount() {
    if (isUserBot) return;

    const { community, currentPage, isLoggedIn, post } = this.props;
    const pageType = currentPage === 'home' ? 'index' : currentPage;
    const postId = currentPage === 'post' && post ? post.id : 'none';
    let tagArray = [];

    if (currentPage === 'post' && post && post.entities.length > 0) {
      tagArray = post.entities.filter(tag => !!tag.urlEncodedName).map(tag => tag.urlEncodedName);
    }

    // Set up Google Publisher Tag (GPT) on each page
    setupGPT({
      isActive: isLoggedIn,
      community: community ? community.slug : 'none',
      postId,
      tagArray,
      pageType,
    });

    Router.events.on('routeChangeStart', handleRouteChange);
  }

  componentWillUnmount() {
    Router.events.off('routeChangeStart', handleRouteChange);
  }

  render() {
    return (
      <React.Fragment>
        <AdvertModal name="advert__modal__1" />
        <AdvertModal name="advert__modal__2" />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentCommunity, currentUser } = state.context;
  return {
    community: currentCommunity,
    isLoggedIn: !!currentUser,
    post: state.pages.singlePost.post,
  };
};

export default connect(mapStateToProps)(AdvertModalContainer);
